import React from "react";
import DocumentLeft from "../../../share-document/components/DocumentLeft";
import { CanvasTool } from "../../canvas";
import { translate } from "../../i18n";

import VodList from "./VodList";
import VodPlayer from "./VodPlayer";

function VodLayout({
    t, mobile, expand, isLeftOpen, setLeftOpen, resize
}) {

    const onClick = () => {
        setLeftOpen(!isLeftOpen);
    };


    return (
        <div className={`addition_layout share_document_layout left_${expand}`} >
            <DocumentLeft mobile={mobile} expand={expand} name={t("layout.vod")}
                isLeftOpen={isLeftOpen} setLeftOpen={setLeftOpen}>
                {/* <AddVodListButton /> */}
                <VodList />
            </DocumentLeft>

            <div className="canvas_tool nonSelect">
                <CanvasTool isLeftOpen={isLeftOpen} setLeftOpen={setLeftOpen} isVod={true} />
            </div>

            <div className="player" style={{ flex: "1", position: "relative", background: "#f7f7f7" }} id="player">
                <VodPlayer resize={resize} expand={expand} 
                    isLeftOpen={isLeftOpen} />
            </div>
        </div>
    );
}

export default translate(VodLayout);